<template>
  <UITooltip text="Auto-refresh the map" placement="bottom">
    <Button
      v-if="isEnabled"
      size="sm"
      variant="secondary"
      icon="ArrowPathIcon"
      @click="emits('disable')"
      class="w-auto md:w-[74px]"
    >
      On
    </Button>

    <Button
      v-else
      size="sm"
      variant="tertiary"
      icon="ArrowPathIcon"
      @click="emits('enable')"
      class="w-auto md:w-[74px]"
    >
      Off
    </Button>
  </UITooltip>
</template>

<script setup>
const emits = defineEmits(['enable', 'disable']);
defineProps({
  isEnabled: {
    type: Boolean,
    default: false,
    required: true,
  },
});
</script>
